import React, { useEffect, useRef } from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useRoute } from "../api"
import { useUrlParams } from '../hooks'
import { useExportPanel, showExportPanel} from '../slices/ui'
import { downloadLink  } from '../utils'

import Loading from './Loading'

import CloseIcon from '../icons/close.svg';
import ShareIcon from '../icons/share.svg';
import GpxIcon from '../icons/gpx.svg';
import LinkIcon from '../icons/link.svg';
import PdfIcon from '../icons/pdf.svg';
import DownloadIcon from '../icons/download.svg';

import settings from '../conf'

import {
  CLOSE,
  DOWNLOAD_GPX,
  DOWNLOAD_LINK,
  DOWNLOAD_PDF,
  ROUTE_SHARE
} from "../trans"


const ExportPanel = (props) => {
  const dispatch = useDispatch()
  const { route_id } = useUrlParams(['route_id'])
  const route = useRoute({ routeId: route_id })
  const history = useHistory()
  const isVisible = useExportPanel(null) 
  const redirectUrl = useRef()
  const isCustom = !route || route?.is_custom

  useEffect(()=>{
    if (!isCustom || !!redirectUrl.current) return

    const saveBeforeLeave = (pathname) => {
      if (redirectUrl.current == null && window.confirm(`Do You like to save your custom trail ?`)) {
          redirectUrl.current = pathname
          dispatch(showExportPanel(true))
          return false;
      }
      return true
    }

    window.addEventListener("beforeunload", saveBeforeLeave);

    let unblock = history.block((tx) => {
      const pathname = tx.pathname
      if (pathname == '/' && window.location.pathname !== settings.BASE_NAME){
        return saveBeforeLeave(pathname)
      }
      return true;
    })
    return () => {
      unblock()
      window.removeEventListener("beforeunload", saveBeforeLeave);
    }

  },[isCustom, dispatch])

  if (!route || !isVisible) return null

  const closeHanled = () =>{
    dispatch(showExportPanel(false))
    if (!redirectUrl.current) return
    history.push({
      pathname: redirectUrl.current,
      state: Object.assign({}, history.state, {dirty: true})
    })
  }

  const pwa = document.getElementById('pwa-install');

  const EXPORT_PROVIDER = [
    { 
      title: 'install',
      isSupported: !pwa.isUnderStandaloneMode && pwa.isInstallAvailable,
      icon: <ShareIcon/>,
      callback: (route) => {
        pwa.install();
      }
    },
    { 
      title: ROUTE_SHARE,
      isSupported: navigator.share !== undefined,
      icon: <ShareIcon/>,
      callback: (route) => {
        const shareData = {
          title: route.title,
          text: route.subtitle,
          url: window.location.href,
        }
        navigator.share(shareData);
      }
    },
    {
      title: DOWNLOAD_LINK,
      icon: <LinkIcon/>,
      isSupported: window.File !== undefined,
      callback: (route) => {
        downloadLink(route.title, window.location.href)
      }
    },
    {
      title: DOWNLOAD_GPX,
      icon: <GpxIcon/> ,
      isSupported: true,
      callback: (route) => {
        window.open(settings.DOWNLOAD_GPX_URL.replace('route_uuid', route.route_id))
      }
    },
    {
      title: DOWNLOAD_PDF,
      icon: <PdfIcon/> ,
      isSupported: true,
      callback: (route) => {
        window.open(settings.DOWNLOAD_PDF_URL.replace('route_uuid', route.route_id))
      }
    }
  ]

  return (
    <div className="pwa__exportpanel fade-in">
      <ul>
         {EXPORT_PROVIDER.map(function(provider, i){
           if (!provider.isSupported) return null
           const clickHandler = () =>{
              provider.callback(route)
           }
           return(
             <li key={i}>
               <button className="button secondary fa circular pwa__exportpanel__button"
                       onClick={clickHandler}>
                 {provider.icon}
                 <div>
                   {provider.title}
                 </div>
               </button>
             </li>
           )
        })}
        <li>
            <button className="button basic circular fa pwa__exportpanel__close" 
                    onClick={closeHanled}>
              <CloseIcon/>
            </button>
        </li>
      </ul>
    </div>
  )
  
}

export default ExportPanel
